import { useQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { AvSourcesDto } from '@/types/dtos/player/response/av-sources.dto';
import type { PlayerParentEntity } from '@/types/dtos/player/player-parent-entity';

export const GET_AV_SOURCES_QUERY_KEY = 'get-av-sources';

export const useGetAvSourcesQuery = (
  data?: { entityId: string; entityType: PlayerParentEntity; eventSlotId?: string | null },
  options?: { enabled?: boolean },
) => {
  const { getToken } = useAuth();
  const enabled = !!data?.entityId && (options?.enabled ?? true);

  return useQuery({
    queryKey: [GET_AV_SOURCES_QUERY_KEY, data?.entityId, data?.entityType, data?.eventSlotId],
    queryFn: async () => {
      const token = await getToken();
      return getAvSources({ token: token ?? '', data: data! });
    },
    enabled,
    staleTime: 5_000,
  });
};

const getAvSources = async ({
  token,
  data,
}: {
  token: string;
  data: { entityId: string; entityType: PlayerParentEntity; eventSlotId?: string | null };
}): Promise<AvSourcesDto> => {
  const params = new URLSearchParams({
    entityId: data.entityId,
    entityType: data.entityType,
  });
  if (data.eventSlotId) {
    params.set('eventSlotId', data.eventSlotId);
  }
  const url = `${import.meta.env.VITE_API_URL}/player/av-sources?${params.toString()}`;
  return sendJSONRequest({ url, method: METHOD.GET, token });
};
